class CartNotificationRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-notification').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-notification-remove-button', CartNotificationRemoveButton);


class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    // this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    this.notification.addEventListener('click', (evt) => {
      if(evt.target.closest('.cart-notification__close')){
        this.close();
      }
    });

    // From <cart-items>

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    console.log("Cart notification")

  }

  connectedCallback() {
    console.log("Cart notification callback")
    restoreSession(this);
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id)
    });
    
    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => response.json())
    .then((response) => {
      digestCart(response);
      this.renderContents(response);
      let totalPrice = response.total_price/100;
      if(document.querySelector(".totals__subtotal-value")){
        document.querySelector(".totals__subtotal-value").textContent = `$${totalPrice.toFixed(2)}`;
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.disableLoading();
    });

  }

  enableLoading(line) {
    document.getElementById('cart-notification-items').classList.add('cart-notification-items--disabled');
    document.activeElement.blur();
  }

  disableLoading() {
    document.getElementById('cart-notification-items').classList.remove('cart-notification-items--disabled');
  }


  //

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, shoulOpen = true) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      // if (this.header) this.header.reveal();
      if(shoulOpen) {
        this.open();
      }
  }

  getSectionsToRender() {
    let mainCartSections = []
    if(location.pathname == "/cart") {
      mainCartSections.push(
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        }
      )
    }
    return [
      {
        id: 'cart-notification-header',
      },
      {
        id: 'cart-notification-items',
      },
      {
        id: 'cart-notification-footer',
      },
      {
        id: 'cart-icon-bubble'
      }
    ].concat(mainCartSections);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }


}

customElements.define('cart-notification', CartNotification);

